import HostedDesktopLayout from '../../../layouts/DesktopLayout';
import HostedInitScreen from '../shared/InitScreen';

export default function HostedDesktopInitPage() {
  return (
    <HostedDesktopLayout>
      <HostedInitScreen />
    </HostedDesktopLayout>
  );
}
